<!-- 加入协会/俱乐部 -->
<template>
<div>
    <el-form :model="ruleForm2" :rules="rules" ref="ruleForm2" label-width="100px">
        <el-row>
            <el-col :span="12">
                <el-form-item label="选择协会" prop="clubName">
                    <el-select v-model="ruleForm2.clubName" style="width:100%">
                        <el-option 
                            v-for="item in clubOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="协会角色" prop="clubRole" >
                    <el-select v-model="ruleForm2.clubRole" style="width:100%">
                        <el-option 
                            v-for="item in clubRoleOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                    </el-select>
                </el-form-item>   
            </el-col>
        </el-row>
        <el-form-item label="入会理由" prop="reason">
            <el-input type="textarea" :rows="4" v-model="ruleForm2.reason" placeholder="入会理由"/>
        </el-form-item> 
        <el-form-item>
            <el-button type="primary" :loading="false" style="width: 220px;"
                @click="clubSubmit('ruleForm2')">提交</el-button>
        </el-form-item>
    </el-form>
</div>
</template>

<script>
export default {
    data() {
        return {
            ruleForm2: {
                clubRole: '',
                reason: '',
                clubName: '',
            },
            rules: {
                reason: [
                    { required: true, message: '请输入入会理由', trigger: 'blur' },
                ],
                clubRole: [
                    { required: true, message: '请选择协会角色', trigger: 'change' }
                ],
                clubName: [
                    { required: true, message: '请选择协会', trigger: 'change' }
                ]
            },
            clubOption: [],
            clubRoleOption: [],
        }
    },
    created() {

    },
    mounted() {
        this.getUserAssocication()
        this.getClubRole()
    },
    methods: {
        // 查询所有协会
        getUserAssocication(){
            let params = {
                opcode: this.$code.UserAssociation,
                i_client_no:  0
            }
            this.$api._requestAPI(params).then(res => {
                if (res.IsSuccess) {   
                    let result = res.Data.DataTable
                    this.clubOption = result.map(item =>{
                        return{
                            value: item['协会(俱乐部)账号'],
                            label: item['协会(俱乐部)全称'],
                        }
                    })
                }
            })
        },
        // 获取协会角色
        getClubRole(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 11,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.clubRoleOption = result.map(item=>{
                        return{
                            value: item['词条索引'],
                            label: item['中文描述']
                        }
                    })
                }
            })
        },
        clubSubmit(formName){
            let { reason, clubName, clubRole} = this.ruleForm2
            this.$refs[formName].validate((valid) => {
                if(valid){
                    let params = {
                        opcode: this.$code.ApplyClub,
                        i_client_no: clubName,
                        v_reason: reason,
                        i_type: clubRole
                    }
                    this.$api.requestAPI(params).then(res => {
                        if (res.IsSuccess) {
                            this.$message.success(res.Message)
                        }else{
                            this.$message.error(res.Message)
                        }
                    })
                }else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
    }
}
</script>
<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/views/userInfo/components/joinClub.vue